export default "__VITE_ASSET__BMH24$bm__"